<template>
  <div class="vip-entry">
    <a-popover id="test" v-model="visible">
      <template slot="content">
        <p class="log">
          <img src="@/assets/images/v1.png" alt="" />
          <span>专享优质资源</span>
        </p>
        <p class="log">
          <img src="@/assets/images/v2.png" alt="" />
          <span>百强重点校资源</span>
        </p>
        <p class="log">
          <img src="@/assets/images/v3.png" alt="" />
          <span>尊享精品资源</span>
        </p>
        <p class="log">
          <img src="@/assets/images/v4.png" alt="" />
          <span>极速下载通道</span>
        </p>
        <p class="log">
          <img src="@/assets/images/v5.png" alt="" />
          <span>尊贵会员标志</span>
        </p>
        <p style="text-align: center;margin-bottom: 0px;">
          <button v-show="isOpen" class="renew-btn ant-btn" @click="reNewNow">
            立即续费
          </button>
          <button v-show="!isOpen" class="renew-btn ant-btn" @click="toOpen">
            立即开通
          </button>
        </p>
      </template>
      <a href="javascript:void(0)" class="top-label">
        <img
          style="vertical-align: text-top;margin-right: 7px;"
          class="member"
          src="@/assets/images/vip.png"
        />会员</a
      >
    </a-popover>
  </div>
</template>
<script>
import { throttle, debounce } from 'throttle-debounce'
import { getOpenInfoApi } from '@/apps/personal/models/api'
export default {
  name: 'VipEntry',
  data() {
    return {
      isOpen: false,
      visible: this.value
    }
  },
  props: {},
  components: {},
  methods: {
    toOpen() {
      console.log('立即开通')
      this.visible = false
      this.$store.commit('SET_PAYMODAL', { state: true, index: 0 })
    },
    reNewNow() {
      console.log('立即续费')
      this.visible = false
      this.$store.commit('SET_PAYMODAL', { state: true, index: 0 })
    },
    async getOpenInfo() {
      let d = await getOpenInfoApi()
      console.log(d)
      if (d.success) {
        this.isOpen = d.msg == '立即开通' ? false : true
      }
    }
  },
  mounted() {
    let target = document.querySelector('#test')
    target.addEventListener('mouseover', throttle(2000, this.getOpenInfo))
  }
}
</script>
<style lang="scss" scoped>
.top-label {
  .member {
    width: 20px;
    height: 17px;
  }
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
}
.ant-popover-inner-content {
  .renew-btn {
    width: 104px;
    height: 32px;
    background: rgba(202, 152, 82, 1);
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }
  p.log {
    img {
      vertical-align: sub;
    }
    span {
      margin-left: 10px;
      width: 84px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(118, 92, 61, 1);
      line-height: 20px;
    }
  }
}
.vip-entry {
  display: inline-block;
}
</style>
